<template>
  <div class="payment_container">
    <cv-navbar class="navbar" />
    <div :style="{ height: nonChrome ? '96px' : '56px' }"></div>
    <div class="container_supervip">
      <div class="supervip_main">
        <div class="main_header">
          <div class="main_header_img">
            <img
              src="https://files.wondercv.com/pc/member/top-icon.png"
              alt=""
            />
          </div>
          <div class="main_header_title">
            <span>超级简历会员</span>
            <p>尊享 6 大特权，求职路上畅通无阻</p>
          </div>
        </div>
      </div>
    </div>

    <div class="mask-container">
      <div class="mask-layout"></div>
      <div class="vip_container">
        <div class="vip_item_layout" v-for="(item, index) in opt" :key="index">
          <!-- 优惠倒计时 -->
          <div v-if="displayCountdownTitle(item)" class="vip-countdown-wrapper">
            <div>{{ displayCountdownTitle(item) }}</div>
            <Countdown
              :start-time="purchaseRecordData && purchaseRecordData.order_time"
              :current-time="purchaseRecordData && purchaseRecordData.time_now"
              :duration="memberPopupData.duration"
              countdown-type="pink"
            ></Countdown>
          </div>
          <!-- 会员选项卡片上面价格部分 -->
          <div :class="changeVipStyle(item)">
            <span
              :class="
                item.type === 'plus'
                  ? 'vip-name-text fontSizeColor'
                  : 'vip-name-text'
              "
              >{{ item.name }}</span
            >
            <div class="vip_price_layout">
              <span
                :class="
                  item.type === 'plus'
                    ? 'vip-unit-text fontSizeColor'
                    : 'vip-unit-text'
                "
                >{{ vipDescTemplate.unit1 }}</span
              >
              <span
                :class="
                  !isSuper(item)
                    ? 'vip-price-text'
                    : item.type === 'plus'
                    ? 'final-vip-price-text fontSizeColor'
                    : 'final-vip-price-text'
                "
                >{{ item.price }}</span
              >
              <span
                :class="
                  item.type === 'plus'
                    ? 'vip-unit-text fontSizeColor'
                    : 'vip-unit-text'
                "
                >{{ vipDescTemplate.unit2 }}</span
              >
            </div>
            <div>
              <del
                :class="
                  item.type === 'plus'
                    ? 'old-pic fontSizeColor'
                    : 'old-pic'
                "
                >￥{{ item.oldPic }}</del
              >
            </div>
            <div
              :class="
                isSuperChange(item)
                  ? 'vip-btn-layout'
                  : item.name === '终身会员'
                  ? 'final-vip-btn-layout'
                  : 'final-vip-btn-layout fontSizeColor bg'
              "
              @click="changeActive(item.price)"
              data-growing-container
              :data-growing-idx="index"
            >
              <span class="iconfont iconhuaban">
                {{ vipDescTemplate.upgradeVipText }}</span
              >
            </div>
          </div>
          <!-- 功能权益/求职权益说明 -->
          <div class="vip-desc-container">
            <!-- 功能权益 -->
            <div class="function-title">
              <div class="left"></div>
              <div class="descript">功能权益</div>
              <div class="right"></div>
            </div>
            <div
              class="vip-desc-layout"
              v-for="(descItem, descIndex) in vipDescTemplate.descArr"
              :key="descItem.desc"
            >
              <!-- 左侧文字 -->
              <span
                :class="
                  !getDescClass(item, descIndex)
                    ? 'vip-desc-gray-text'
                    : 'vip-desc-black-text'
                "
                >
                {{ formatDesc(descItem.desc, index) }}
              </span>
              <!-- 右侧的权益 -->

              <!-- 可拥有简历数 -->
              <span
                v-if="descItem.childDesc === '15'"
                class="vip-desc-gold-text"
                :class="{
                  'vip-check':
                    vipDescTemplateMapping[descItem.desc] &&
                    vipDescTemplateMapping[descItem.desc][item.price],
                }"
              >
                {{
                  vipDescTemplateMapping[descItem.desc] &&
                  vipDescTemplateMapping[descItem.desc][item.price]
                    ? vipDescTemplateMapping[descItem.desc][item.price]
                    : descItem.childDesc
                }}
              </span>

              <!-- AI智能检查 & 中英一键翻译 -->
              <template v-if="descItem.childDesc === '无限'">
                <span
                  v-if="
                    vipDescTemplateMapping[descItem.desc] &&
                    vipDescTemplateMapping[descItem.desc][item.price]
                  "
                  class="vip-desc-gold-text vip-check"
                >
                  {{ vipDescTemplateMapping[descItem.desc][item.price] }}
                </span>
                <span
                  v-else
                  class="vip-desc-gold-text iconfont iconhuabanbeifen"
                >
                  {{ descItem.childDesc }}
                </span>
              </template>

              <!-- 暂时没有，看descArr数组 -->
              <img
                v-if="
                  descItem.childDesc === '限时' &&
                  ((descIndex > 5 && isSuper(item)) || descIndex === 4)
                "
                class="times-text"
                src="@/assets/image/member/desc_time.png"
                
              />
              
              <!-- 终身会员 会员简历模版 -->
              <span
                class="vip-desc-gold-text iconfont iconhuabanbeifen"
                v-if="
                  descItem.childDesc === '对勾' &&
                  descItem.desc === '会员简历模板' &&
                  (item.type == 'forever' || item.type === 'plus')
                "
              >
                无限
              </span>

              <!-- 限时 会员简历模版 -->
              <img
                class="times-text-life"
                src="@/assets/image/member/template.png"
                v-if="
                  descItem.childDesc === '限时' &&
                  descItem.desc === '会员简历模板' &&
                  isSuper(item)
                "
              />

              <!-- 非终身会员 会员简历模版 -->
              <span
                v-if="descItem.desc === '会员简历模板' && !isSuper(item)"
                class="iconfont iconziyuanldpi vip-check"
              ></span>

              <!-- 终身会员，index > 5 || 非终身会员 index === 6 即数组中的会员求职社区 -->
              <span
                v-if="
                  descItem.childDesc === '对勾' &&
                  ((descIndex > 5 && isSuper(item)) || descIndex === 6 )
                "
                class="iconfont iconziyuanldpi vip-check"
              ></span>

              <!-- 证件照制作 -->
              <span
                v-if="descItem.childDesc === '次数'"
                class="vip-desc-gold-text"
                :class="{ 'super-text': !isSuper(item) }"
              >
                {{ isSuper(item) ? 5 : 1 }} 次
              </span>

              <!-- 简历语义一键纠错 -->
              <span
                v-if="descItem.childDesc === 'giftTimes'"
                class="vip-desc-gold-text"
                :class="{ 'super-text': !isSuper(item) }"
              >
                {{ isSuper(item) ? 100 : 10 }} 次
              </span>
            </div>
            <!-- 求职权益 -->
            <div class="jobs-title">
              <div class="left"></div>
              <div class="descript">求职权益</div>
              <div class="right"></div>
            </div>

            <div
              class="vip-desc-layout"
              v-for="(descItem, descIndex) in vipDescTemplate.descArr2"
              :class="{ 'cursor-p': descIndex === 1 || descIndex === 3 }"
              :key="descItem.desc"
              @click="descHandleClick(descIndex)"
            >
              <!-- 左侧文字 -->
              <span
                :class="
                  item.type !== 'forever'
                    ? 'vip-desc-gray-text'
                    : 'vip-desc-black-text'
                "
              >
                {{ formatDesc(descItem.desc, index) }}
              </span>

               <!-- 下面这一部分可以只看 对勾的情况，别的暂时好像没什么用了 -->
              <span
                v-if="descItem.childDesc === '15'"
                class="vip-desc-gold-text"
                :class="{
                  'super-text':
                    vipDescTemplateMapping[descItem.desc] &&
                    vipDescTemplateMapping[descItem.desc][item.price],
                }"
              >
                {{
                  vipDescTemplateMapping[descItem.desc] &&
                  vipDescTemplateMapping[descItem.desc][item.price]
                    ? vipDescTemplateMapping[descItem.desc][item.price]
                    : descItem.childDesc
                }}
              </span>

              <template v-if="descItem.childDesc === '无限'">
                <span
                  v-if="
                    vipDescTemplateMapping[descItem.desc] &&
                    vipDescTemplateMapping[descItem.desc][item.price]
                  "
                  class="vip-desc-gold-text super-text"
                  >{{
                    vipDescTemplateMapping[descItem.desc][item.price]
                  }}</span
                >
                <span
                  class="vip-desc-gold-text iconfont iconhuabanbeifen"
                  v-else
                  >{{ descItem.childDesc }}</span
                >
              </template>

              <img
                class="times-text"
                src="@/assets/image/member/desc_time.png"
                v-if="
                  descItem.childDesc === '限时' &&
                  ((descIndex > 5 && isSuper(item)) || descIndex === 4)
                "
              />

              <img
                class="times-text-life"
                src="@/assets/image/member/template.png"
                v-if="
                  descItem.childDesc === '限时' &&
                  descItem.desc === '会员简历模板' &&
                  isSuper(item)
                "
              />

              <span
                v-if="
                  descItem.childDesc === '限时' &&
                  descItem.desc === '会员简历模板' &&
                  !isSuper(item)
                "
                class="iconfont iconziyuanldpi vip-check"
              ></span>

              <span
                v-if="
                  descItem.childDesc === '对勾' &&
                  ((descIndex > 5 && isSuper(item)))
                "
                class="iconfont iconziyuanldpi vip-check"
              ></span>

              <span
                v-if="
                  descItem.childDesc === '对勾' &&
                  (item.type === 'forever')
                "
                class="iconfont iconziyuanldpi vip-check"
              ></span>

              <span
                v-if="descItem.childDesc === '次数'"
                class="vip-desc-gold-text"
                :class="{ 'super-text': !isSuper(item) }"
                >{{ isSuper(item) ? 5 : 1 }} 次</span
              >

              <span
                v-if="descItem.childDesc === 'giftTimes'"
                class="vip-desc-gold-text"
                :class="{ 'super-text': !isSuper(item) }"
                >{{ isSuper(item) ? 100 : 10 }} 次</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 反馈 -->
    <div class="container_feedback">
      <div class="fdback_main">
        <div class="main_title">会员使用反馈</div>
        <div class="main_detail">
          <div
            class="detail_item"
            v-for="(item, index) in feedback"
            :key="index"
          >
            <div class="item_fdb" v-html="item.mes"></div>
            <div class="item_intro">
              <img class="intro_avator" :src="item.avator" alt="" />
              <div class="intro_info">
                <p class="name">{{ item.name }}</p>
                <p class="info">{{ item.info }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="container_sum">
      <div class="sum_main">
        <div class="main_intro">
          <div class="intro_item">
            <p>200000+</p>
            <p>200000+ 尊享会员用户</p>
          </div>
          <div class="intro_item">
            <p>130000+</p>
            <p>130000+ 大牛简历模板</p>
          </div>
          <div class="intro_item">
            <p>100+</p>
            <p>100+ 专属求职社群</p>
          </div>
        </div>
        <div class="main_btn" @click="handleCreateOrder(1000)">
          <p>
            {{ personInfo.is_membership === true ? '立即续费' : '立即开通' }}
          </p>
        </div>
      </div>
    </div>
    <pay-alert
      v-if="showAlert"
      @close="showAlert = false"
      :active-pic="active"
    />
    <pcFooter />
  </div>
</template>

<script>
import cvNavbar from '@/components/base/navbar'
import pcFooter from '@/components/base/pcFooter'
import payAlert from './payAlert'
import api from '../../../api'
import { toLogin } from '@/assets/js/jwt'
import Cookies from 'js-cookie'
import { mapState, mapGetters } from 'vuex'
import Countdown from '@/components/Countdown'
import { MONTH_PRICE, YEAR_PRICE, FOREVER_PRICE, FOREVER_PLUS_PRICE, WONDER_PRICE } from '@/assets/js/const'

import timeLimiteQuity from '@/assets/image/member/timeLimite-quity.png'

const moment = require('moment')
export default {
  components: {
    cvNavbar,
    pcFooter,
    payAlert,
    Countdown,
  },
  computed: {
    ...mapState('global', ['nonChrome']),
    ...mapState('me', ['isLogin', 'personInfo', 'purchaseRecordData']),
    ...mapGetters('me', ['memberPopupData']),
    changeVipStyle() {
      return function (item) {
        return item.type === 'month' || item.type === 'year'
          ? 'vip_item_child_layout'
          : item.type === 'forever'
          ? 'final-member-layout'
          : 'vip_item_child_layout plus-bg'
      }
    },
    isSuper() {
      return function (item) {
        return item.type === 'forever' || item.type === 'plus'
      }
    },
    isSuperChange() {
      return function (item) {
        return item.type === 'month' || item.type === 'year'
      }
    },

    isSuperMember() {
      return (
        this.personInfo.is_membership &&
        this.personInfo.membership_expired_at.substr(0, 4) >= 2100
      )
    },
  },
  data() {
    const vipTemplateText = {
      unit1: '¥',
      unit2: '元',
      upgradeVipText: '升级会员',
      cvNumber: 15,
      checkMark: '√',
      infinite: '∞ 无限',
      descArr: [
        { desc: '可拥有简历份数', childDesc: '15' },
        { desc: 'AI 智能检查', childDesc: '无限' },
        { desc: '中英一键翻译', childDesc: '无限' },
        { desc: '会员简历模板', childDesc: '对勾' },
        { desc: '证件照极速制作一键导出', childDesc: '次数' },
        { desc: '简历文本语义一键纠错', childDesc: 'giftTimes' },
        { desc: '会员专属求职社群', childDesc: '对勾' },
        { desc: 'AI模拟面试', childDesc: '无限' },
        { desc: 'AI简历润色', childDesc: '无限' },
        { desc: '365天回收站简历恢复', childDesc: '对勾' },
      ],
      descArr2: [
        // { desc: '199元笔面试通关秘籍', childDesc: '对勾' },
        // { desc: '79元精选简历课', childDesc: '对勾' },
        // { desc: '500元求职服务优惠券', childDesc: '对勾' },
        { desc: '精选求职包', childDesc: '对勾' },
        { desc: '专属客服', childDesc: '对勾' },
      ],
      descArr3: [
        { desc: '159元 1V1 简历优化', childDesc: '次数' },
        { desc: '可拥有简历份数', childDesc: '15' },
        { desc: 'AI 智能检查', childDesc: '无限' },
        { desc: '中英一键翻译', childDesc: '无限' },
        { desc: '会员简历模板', childDesc: '无限' },
        { desc: '证件照极速制作一键导出', childDesc: '次数' },
        { desc: '简历文本语义一键纠错', childDesc: 'giftTimes' },
        { desc: '365天回收站简历恢复', childDesc: '对勾' },
        { desc: '会员专属求职社群', childDesc: '对勾' },
        { desc: '199元笔面试通关秘籍', childDesc: '对勾' },
        { desc: '79元精选简历课', childDesc: '对勾' },
        { desc: '500元求职服务优惠券', childDesc: '对勾' },
      ],
    }
    const option = [
      {
        name: '终身会员',
        price: FOREVER_PRICE,
        oldPic: 199.9,
        time: '终身',
        des: '最实惠 越用越省',
        giftTimes: 100,
        type: 'forever'
      },
      {
        name: '月会员',
        price: MONTH_PRICE,
        oldPic: 25.9,
        time: '30天',
        des: '平均每天 0.6 元',
        giftTimes: 10,
        type: 'month'
      },
      // {name: "季会员", price: 45, time: "90天", des: "平均每天 0.5 元", giftTimes: 10},
      {
        name: '年会员',
        price: YEAR_PRICE,
        oldPic: 99.9,
        time: '一年',
        des: '平均每天 0.2 元',
        giftTimes: 10,
        type: 'year'
      },
      // {
      //   name: '终身会员PLUS',
      //   price: FOREVER_PLUS_PRICE,
      //   oldPic: 1199.9,
      //   time: '终身',
      //   des: '最实惠 越用越省',
      //   giftTimes: 100,
      //   type: 'plus'
      // },
      // {
      //   name: '超级会员',
      //   price: WONDER_PRICE,
      //   oldPic: 1199.9,
      //   time: '终身',
      //   des: '最实惠 越用越省',
      //   giftTimes: 100,
      //   type: 'wonder'
      // },
    ]
    const pri = [
      {
        icon: 'https://files.wondercv.com/pc/member/member-1.png',
        title: '简历份数',
        info: '15份 简历实时编辑',
        info1: '',
      },
      {
        icon: 'https://files.wondercv.com/pc/member/member-2.png',
        title: '简历制作',
        info: '无限次 AI 智能改简历',
        info1: '无限次中英简历一键翻译',
      },
      {
        icon: 'https://files.wondercv.com/pc/member/member-5.png',
        title: '简历模板',
        info: '全站简历模板任意使用',
        info1: '',
      },
      {
        icon: 'https://files.wondercv.com/pc/member/member-4.png',
        title: '简历恢复',
        info: '回收站简历 365天 可恢复',
        info1: '（终身会员专享）',
      },
      {
        icon: 'https://files.wondercv.com/pc/member/payment_fuli.png',
        title: '会员福利',
        info: '会员专属求职社群',
        info1: ' 20元 导师辅导优惠券',
        info2: '（终身会员专享）',
      },
      {
        icon: 'https://files.wondercv.com/pc/member/member-6.png',
        title: '其他福利',
        info: '价值 50元 MBTI 测试报告',
        info1: '（终身会员专享）',
      },
    ]
    const fdb = [
      {
        avator: 'https://files.wondercv.com/pc/member/payment_1.png',
        mes: "因为想针对不同的职位准备简历，所以需要<span style='color: #ff6644'>简历份数多</span>一些，另外<span style='color: #ff6644'>无限次智能检查</span>的功能特别棒，帮我改掉了很多问题。",
        name: '张同学',
        info: '互联网行业',
      },
      {
        avator: 'https://files.wondercv.com/pc/member/payment_2.png',
        mes: "我准备投递海外的岗位，需要有几份英文简历。会员可以无限次把中文简历<span style='color: #ff6644'>一键翻译</span>为英文简历，非常好用。",
        name: '陈先生',
        info: '金融行业',
      },
      {
        avator: 'https://files.wondercv.com/pc/member/payment_3.png',
        mes: "作为一个写简历经验为0的小白，购买会员后，全行业的<span style='color: #ff6644'>简历模板任意使用</span>，简直是天大的帮助！",
        name: '王同学',
        info: '快消行业',
      },
      {
        avator: 'https://files.wondercv.com/pc/member/payment_4.png',
        mes: "买了终身会员后，用赠送的<span style='color: #ff6644'>导师辅导优惠券</span>体验了超级简历的职业规划、简历修改、模拟面试，后面顺利拿到了大厂offer～",
        name: '刘女士',
        info: '教育行业',
      },
      {
        avator: 'https://files.wondercv.com/pc/member/payment_5.png',
        mes: "会员<span style='color: #ff6644'>专属求职社群</span>里，每天都有很多高质量的岗位信息，大家会讨论求职技巧，还有大佬经常分享笔经、面经。宝藏群聊！",
        name: '杨同学',
        info: '广告行业',
      },
      {
        avator: 'https://files.wondercv.com/pc/member/payment_6.png',
        mes: "我本来对我的职业方向很迷茫，在体验了<span style='color: #ff6644'>导师辅导服务</span>后，认识到自己的职业竞争力，现在更明确以后的求职方向了。",
        name: '赵小姐',
        info: '咨询行业',
      },
    ]
    return {
      defaultImg: {
        timeLimiteQuity,
      },
      moment,
      opt: option,
      vipDescTemplate: vipTemplateText,
      vipDescTemplateMapping: {
        '可拥有简历份数': {
          [MONTH_PRICE]: 5,
          [YEAR_PRICE]: 5,
        },
        'AI模拟面试': {
          [MONTH_PRICE]: 30,
          [YEAR_PRICE]: 30
        },
        'AI简历润色': {
          [MONTH_PRICE]: 100,
          [YEAR_PRICE]: 100
        },
        '159元 1V1 简历优化': {
          199: 1,
        },
        'AI 智能检查': {
          [MONTH_PRICE]: 100,
          [YEAR_PRICE]: 1500,
        },
        '中英一键翻译': {
          [MONTH_PRICE]: 10,
          [YEAR_PRICE]: 200,
        },
      },
      active: FOREVER_PRICE,
      privilege: pri,
      feedback: fdb,
      showAlert: false,
      orderId: '',
    }
  },
  methods: {
    displayCountdownTitle(vipItem) {
      if (this.purchaseRecordData) {
        const { state } = this.purchaseRecordData;
        switch(state) {
          case 2:
            return vipItem.type === 'forever' ? '新客特惠' : '';
          case 4:
            return vipItem.type === 'forever' ? '限时立减' : ''
        }
      }
    },
    descHandleClick(index) {
      if (index === 1 || index === 9) {
        window.open(`${location.origin}/course`)
      } else if (index === 3) {
        window.open(`${location.origin}/service/`)
      }
    },
    formatDesc(text, index) {
      if (index === 3) {
        return text.replace(/39元1/g, '49元1')
      }
      return text
    },
    changeActive(price) {
      this.active = price
      this.showAlert = true
      // this.handleCreateOrder()
    },
    async handleCreateOrder(pic) {
      let _t = Cookies.get('_t')
      if (!_t) {
        toLogin({ login: true })
        return
      }
      try {
        let member_period = 1000
        if (pic !== 1000) {
          if (this.active === MONTH_PRICE) {
            member_period = 1
          } else if (this.active === 45) {
            member_period = 3
          } else if (this.active === YEAR_PRICE) {
            member_period = 12
          } else if (this.active === FOREVER_PRICE) {
            member_period = 1000
          } else if (this.active === 119) {
            member_period = 2000
          }
        }
        let res = await api.account.createOrder({ member_period, has_rights: 'true' })
        let {
          code,
          data: { token },
        } = res
        if (code === 1000) {
          this.orderId = token
          this.showAlert = true
        }
      } catch (e) {
        console.log(e)
      }
    },
    invitation() {
      let alertData = {
        show: true,
        type: 'upVip',
        browseType: 'invite',
      }
      this.$store.dispatch('app/setAlertData', alertData)
    },
    // 获取是否有权限的class
    getDescClass(item, descIndex) {
      if (descIndex < 9) {
        return true
      } else if (item.type === 'forever' && descIndex <= 10) {
        return true
      } else if (item.type === 'plus') {
        return true
      }
      return false
    },
    mouseenterFn(info) {
      if (info === '159元 1V1 简历优化') {
        document.querySelector('.hover-div').classList.add('block')
      }
    },
    mouseleave(info) {
      if (info === '159元 1V1 简历优化') {
        document.querySelector('.hover-div').classList.remove('block')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './buy_member.scss';
</style>
